<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <!-- Start:: Filter -->
    <div class="main-filter filter-content mb-5">
      <div
        class="contents row w-100 m-0 py-3 mx-1 justify-content-start align-items-center bg-white rounded shadow-sm"
      >
        <!-- Driver Selector -->
        <div class="col-lg-3 col-md-6 py-2">
          <div class="input_wrapper top_label">
            <multiselect
              v-model="filter.driver"
              :options="drivers"
              label="name"
              track-by="id"
              :showLabels="false"
              placeholder=" "
              :searchable="true"
              :allow-empty="true"
              @input="handleFilterChange"
            ></multiselect>
            <label class="form-label">السائق</label>
          </div>
        </div>

        <!-- Admin Selector -->
        <div class="col-lg-3 col-md-6 py-2">
          <div class="input_wrapper top_label">
            <multiselect
              v-model="filter.admin"
              :options="admins"
              label="name"
              track-by="id"
              :showLabels="false"
              placeholder=" "
              :searchable="true"
              :allow-empty="true"
              @input="handleFilterChange"
            ></multiselect>
            <label class="form-label">الأدمن المطبق</label>
          </div>
        </div>

        <!-- Order ID Input -->
        <div class="col-lg-2 col-md-6 py-2">
          <div class="input_wrapper top_label">
            <label class="form-label">رقم الطلب</label>
            <v-text-field
              v-model="filter.order_id"
              placeholder="رقم الطلب"
              @input="handleFilterChangeDebounced"
              clearable
            ></v-text-field>
          </div>
        </div>

        <!-- Created From Date -->
        <div class="col-lg-2 col-md-6 py-2">
          <div class="input_wrapper top_label">
            <label class="form-label">تاريخ البداية (من)</label>
            <v-menu
              v-model="dateStartModal"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filter.created_from"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  placeholder="تاريخ البداية"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filter.created_from"
                no-title
                scrollable
                @input="onStartDateInput"
              >
                <v-btn text color="primary" @click="clearStartDate">
                  الغاء
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>

        <!-- Created To Date -->
        <div class="col-lg-2 col-md-6 py-2">
          <div class="input_wrapper top_label">
            <label class="form-label">تاريخ النهاية (إلى)</label>
            <v-menu
              v-model="dateEndModal"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filter.created_to"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  placeholder="تاريخ النهاية"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filter.created_to"
                no-title
                scrollable
                @input="onEndDateInput"
              >
                <v-btn text color="primary" @click="clearEndDate">
                  الغاء
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
    </div>
    <!-- End:: Filter -->

    <transition name="fadeInUp" mode="out-in" v-if="loaderPage">
      <MainLoader />
    </transition>

    <div class="fadeIn" v-else>
      <!-- Start Main Section -->
      <main class="magic-table-wrapper">
        <v-data-table
          class="thumb strip"
          :headers="headers"
          :items="rows"
          :loading="loading_table"
          :loading-text="$t('table.loadingData')"
          item-key="id"
          :items-per-page="paginations.items_per_page"
          hide-default-footer
        >
          <!-- Select no data State -->
          <template v-slot:no-data>
            {{ $t("table.noData") }}
          </template>

          <template v-slot:[`item.index`]="{ index }">
            {{ index + 1 }}
          </template>

          <!-- Driver Name -->
          <template v-slot:[`item.driver.full_name`]="{ item }">
            <router-link
              v-if="item.driver"
              :to="`/driver/show/${item.driver.id}`"
              class="main_color text-decoration-underline"
            >
              {{ item.driver.full_name }}
            </router-link>
            <span v-else>-</span>
          </template>

          <!-- Note -->
          <template v-slot:[`item.note`]="{ item }">
            <span>{{ item.note || "-" }}</span>
          </template>

          <!-- Admin Name -->
          <template v-slot:[`item.admin.full_name`]="{ item }">
            <span>{{ item.admin ? item.admin.full_name : "-" }}</span>
          </template>

          <!-- Order ID -->
          <template v-slot:[`item.order`]="{ item }">
            <router-link
              v-if="item?.order?.id"
              :to="
                item?.order?.order_type == 'delivery'
                  ? `/delivery_orders/show/${item.order.id}`
                  : `/package_order/show/${item.order.id}`
              "
              class="main_color text-decoration-underline"
            >
              #{{ item.order.id }}
            </router-link>
            <span v-else>-</span>
          </template>

          <!-- Select actions-->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="_actions d-flex">
              <v-icon
                v-if="helper_hasPermission('delete')"
                class="delete"
                small
                @click="deleteItem(item)"
              >
                fal fa-trash
              </v-icon>
            </div>
          </template>

          <!-- ======================== Start Top Section ======================== -->
          <template v-slot:top>
            <!-- Delete dialog -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 justify-center">
                  {{ $t("table.deletedialog.areYouSure") }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1B5E20" @click="deleteItemConfirm">
                    {{ $t("table.deletedialog.ok") }}
                  </v-btn>
                  <v-btn color="#F44336" @click="dialogDelete = false">
                    {{ $t("table.deletedialog.cancel") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <!-- ======================== End Top Section ======================== -->
        </v-data-table>
      </main>
      <!-- End Main Section -->

      <!-- Start Pagination -->
      <template>
        <div
          class="pagination_container text-center mb-5 d-flex justify-content-end mt-4"
        >
          <v-pagination
            color="primary"
            v-model="paginations.current_page"
            :length="paginations.last_page"
            :total-visible="5"
            @input="fetchData($event)"
          ></v-pagination>
        </div>
      </template>
      <!-- End Pagination -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from "lodash/debounce";

export default {
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.drivers.title"),
          disabled: false,
          href: "/driver/show-all",
        },
        {
          text: this.$t("breadcrumb.drivers.fines"),
          disabled: true,
          href: "",
        },
      ],

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,

      // ========== Data Lists for select
      drivers: [],
      admins: [],

      // ========== Filters State
      filter: {
        driver: null,
        admin: null,
        order_id: "",
        created_from: null,
        created_to: null,
      },
      dateStartModal: false,
      dateEndModal: false,

      // ========== Your Data
      rows: [],

      // ========== Main Loader
      loaderPage: false,
      loading_table: false,

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },
    };
  },

  watch: {
    [`$route`]() {
      this.readRouteQueries();
      this.setRows();
    },
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: false,
            width: "80",
          },
          {
            text: "اسم السائق",
            align: "center",
            value: "driver.full_name",
            sortable: false,
          },
          {
            text: "السبب",
            align: "center",
            value: "reason",
            sortable: false,
          },
          {
            text: "الملاحظات",
            align: "center",
            value: "note",
            sortable: false,
          },
          {
            text: "الأدمن المطبق",
            align: "center",
            value: "admin.full_name",
            sortable: false,
          },
          {
            text: "رقم الطلب",
            align: "center",
            value: "order",
            sortable: false,
          },
          {
            text: "تاريخ المخالفة",
            align: "center",
            value: "created_at",
            sortable: false,
          },
          {
            text: "التحكم",
            align: "center",
            value: "actions",
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: false,
            width: "80",
          },
          {
            text: "Driver Name",
            align: "center",
            value: "driver.full_name",
            sortable: false,
          },
          {
            text: "Reason",
            align: "center",
            value: "reason",
            sortable: false,
          },
          {
            text: "Note",
            align: "center",
            value: "note",
            sortable: false,
          },
          {
            text: "Admin",
            align: "center",
            value: "admin.full_name",
            sortable: false,
          },
          {
            text: "Order ID",
            align: "center",
            value: "order_id",
            sortable: false,
          },
          {
            text: "Fine Date",
            align: "center",
            value: "created_at",
            sortable: false,
          },
          {
            text: "Actions",
            align: "center",
            value: "actions",
            sortable: false,
          },
        ];
      }
    },
  },

  methods: {
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `driver_fine/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess") || "تم حذف المخالفة بنجاح",
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response?.data?.message || "فشل حذف المخالفة",
            position: "bottomRight",
          });
        });
    },

    // ===== Filters Handlers
    onStartDateInput(value) {
      this.filter.created_from = value;
      this.dateStartModal = false;
      this.handleFilterChange();
    },
    clearStartDate() {
      this.filter.created_from = null;
      this.dateStartModal = false;
      this.handleFilterChange();
    },
    onEndDateInput(value) {
      this.filter.created_to = value;
      this.dateEndModal = false;
      this.handleFilterChange();
    },
    clearEndDate() {
      this.filter.created_to = null;
      this.dateEndModal = false;
      this.handleFilterChange();
    },

    handleFilterChange() {
      const query = {
        page: 1,
        driver_id: this.filter.driver ? this.filter.driver.id : undefined,
        admin_id: this.filter.admin ? this.filter.admin.id : undefined,
        order_id: this.filter.order_id || undefined,
        created_from: this.filter.created_from || undefined,
        created_to: this.filter.created_to || undefined,
      };

      // Remove undefined/empty values
      Object.keys(query).forEach((key) => {
        if (query[key] === undefined || query[key] === "") {
          delete query[key];
        }
      });

      this.$router.push({ query }).catch(() => {});
    },

    handleFilterChangeDebounced() {
      if (this.debouncedFilterChange) {
        this.debouncedFilterChange();
      }
    },

    readRouteQueries() {
      const query = this.$route.query;
      this.paginations.current_page = query.page ? +query.page : 1;

      // Sync driver filter
      if (query.driver_id) {
        const found = this.drivers.find((d) => d.id == query.driver_id);
        this.filter.driver = found || {
          id: query.driver_id,
          name: `سائق #${query.driver_id}`,
        };
      } else {
        this.filter.driver = null;
      }

      // Sync admin filter
      if (query.admin_id) {
        const found = this.admins.find((a) => a.id == query.admin_id);
        this.filter.admin = found || {
          id: query.admin_id,
          name: `أدمن #${query.admin_id}`,
        };
      } else {
        this.filter.admin = null;
      }

      this.filter.order_id = query.order_id || "";
      this.filter.created_from = query.created_from || null;
      this.filter.created_to = query.created_to || null;
    },

    // ===== Fetch Select Lists
    getDrivers() {
      this.$axios({
        method: "GET",
        url: "driver_not_paginated",
      }).then((res) => {
        this.drivers = res.data.data.map((x) => {
          return {
            id: x.id,
            name: x.full_name,
          };
        });
        this.readRouteQueries();
      });
    },

    getAdmins() {
      this.$axios({
        method: "GET",
        url: "admin_not_paginated",
      }).then((res) => {
        this.admins = res.data.data.map((x) => {
          return {
            id: x.id,
            name: x.full_name,
          };
        });
        this.readRouteQueries();
      });
    },

    // ===== Set Rows (Fetch Main Fines List)
    setRows() {
      this.loading_table = true;

      const params = {
        page: this.paginations.current_page,
        driver_id: this.$route.query.driver_id || undefined,
        admin_id: this.$route.query.admin_id || undefined,
        order_id: this.$route.query.order_id || undefined,
        created_from: this.$route.query.created_from || undefined,
        created_to: this.$route.query.created_to || undefined,
      };

      this.$axios({
        method: "GET",
        url: "driver_fine",
        params: params,
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta?.last_page || 1;
          this.paginations.items_per_page = res.data.meta?.per_page || 20;
          this.rows = res.data.data;
          this.loading_table = false;
        })
        .catch((err) => {
          this.rows = [];
          this.loading_table = false;
          if (err.response?.status !== 422) {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response?.data?.message || "فشل تحميل البيانات",
              position: "bottomRight",
            });
          }
        });
    },

    fetchData(e) {
      this.$router.replace({
        query: Object.assign({}, this.$route.query, { page: e }),
      });
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      this.setRows();
    },
  },

  created() {
    this.debouncedFilterChange = debounce(this.handleFilterChange, 500);
    this.getDrivers();
    this.getAdmins();
    this.readRouteQueries();
    this.setRows();
  },
};
</script>

<style scoped>
.wrraper {
  padding: 20px;
}
.main-filter {
  margin-bottom: 20px;
}
</style>
